export default "__VITE_ASSET__Dv25nNmy__"